module.exports = __webpack_public_path__ + "static/img/33.bf77cb74.jpg";